<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card min-width="500px">
            <v-card-actions class="ma-0 pa-0 pb-3">
                <v-card-text class="blue--text">{{deployedPackage == null ? "" : deployedPackage.name}}</v-card-text>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-3">
                <v-autocomplete
                        v-model="aud"
                        dense
                        :items="audiences"
                        outlined
                        item-text="name"
                        item-value="name"
                        return-object
                        small-chips
                        multiple
                        deletable-chips
                        label="Audiences"
                ></v-autocomplete>
            </v-card-actions>
            <v-card-actions dense class="ma-0 pa-0 mt-7 pb-3">
                <v-spacer></v-spacer>
                <v-btn :loading="working"
                       elevation="0"
                       class="ma-2"
                       color="primary"
                       @click="onPressActivate">SAVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";
import {AudienceModel} from "@/modules/maudiences/models/AudienceModel";

export default {
    name: "p-packages-edit-audience-popup",
    components: {},
    data: () => ({
        dialog: false,
        working:false,
        deployedPackage:null,
        aud:[],
    }),
    computed: {
        audiences(){
            let aud = []
            aud = aud.concat(AudienceTestStoreUtils.getAudiences())
            aud = aud.concat(AudienceTestStoreUtils.getCustomAudiences())
            return aud
        }
    },
    methods: {
        show(deployedPackage) {
            this.deployedPackage = deployedPackage
            let aud = deployedPackage.aud.split(',');
            aud = aud.filter(function (el) {return el != "";});
            for (var a in aud){
                this.aud.push(new AudienceModel(aud[a]));
            }
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose(){
            this.dialog = false
        },
        onPressActivate(){
            if (this.aud.length == 0) {
                this.$notify({title: 'No audiences!', type: "error"});
                return;
            }
            let data = [{name: this.deployedPackage.name, aud: this.aud.map(e => e.name).join(",")}]
            this.working = true
            PackageStoreUtils.setDeployedPackageAudience(data)
            .then(() => {
                this.working = false
                this.dialog = false
                this.$notify({title: 'Package audiences successfully updated!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.working = false
                this.$notify({title: 'Package audiences successfully updated!', text: error, type: "error"});
            })
        }
    }
}
</script>

<style scoped>

</style>